// @flow

import { createActions, handleActions } from 'redux-actions'
import { priceList } from 'stories/molecules/data'

type State = {
  prefecture: string,
  region: string,
  capacity: string,
  price: string,
}

const initialState: State = {
  prefecture: '東京',
  region: '23区内',
  capacity: '定員30名',
  price: '¥230,000',
}

type ACTION_TYPE = {
  payload: {
    prefecture: string,
    region: string,
    capacity: string,
    price: string,
  },
}

export const actions = createActions(
  'SET_PREFECTURE',
  'SET_REGION',
  'SET_CAPACITY',
  'SET_PRICE',
)

export const reducer = handleActions(
  {
    [actions.setPrefecture]: (state: State, action: ACTION_TYPE) => ({
      ...state,
      prefecture: action.payload.prefecture,
    }),
    [actions.setRegion]: (state: State, action: ACTION_TYPE) => ({
      ...state,
      region: action.payload.region,
    }),
    [actions.setCapacity]: (state: State, action: ACTION_TYPE) => ({
      ...state,
      capacity: action.payload.capacity,
    }),
    [actions.setPrice]: (state: State, action: ACTION_TYPE) => ({
      ...state,
      price: action.payload.price,
    }),
  },
  initialState,
)

export async function fetchPrice(
  prefecture: string,
  region: string,
  capacity: string,
) {
  const price = await priceList[prefecture][region][capacity]
  return price
}
